const mainSelector = content => content.child('main');
const authorizedAgentSelector = content => mainSelector(content).child('authorized-agent');
const consumerSelector = content => mainSelector(content).child('consumer');

export const titleSelector = content => content.title;

export const descriptionSelector = content => mainSelector(content).child('html').metadata('htmlContent').value();

export const optOutOfSharingSelector = content =>
  mainSelector(content).child('opt-out-of-sharing').metadata('htmlContent').value();

export const agentsNoteSelector = content =>
  mainSelector(content).child('authorized-agents-note').metadata('htmlContent').value();

export const agentsDescriptionSelector = content =>
  authorizedAgentSelector(content).child('html').metadata('htmlContent').value();

export const consumerDescriptionSelector = content =>
  consumerSelector(content).child('html').metadata('htmlContent').value();

export const employmentAffiliationConsumerSelector = content =>
  authorizedAgentSelector(content).child('employment-affiliation').metadata('htmlContent').value();

export const employmentAffiliationAgentSelector = content =>
  authorizedAgentSelector(content).child('employment-affiliation-agent').metadata('htmlContent').value();

export const businessAffiliationConsumerSelector = content =>
  authorizedAgentSelector(content).child('business-affiliation').metadata('htmlContent').value();

export const businessAffiliationAgentSelector = content =>
  authorizedAgentSelector(content).child('business-affiliation-agent').metadata('htmlContent').value();

export const requestTypesDescriptionsSelector = content =>
  consumerSelector(content)
    .children()
    .filter(child => child.id !== 'html')
    .reduce((children, child) => ({ ...children, [child.id]: child.metadata('htmlContent').value() }), {});
